import * as React from "react"

function SvgChat(props) {
  return (
    <svg height={512} viewBox="0 0 512 512" width={512} {...props}>
      <path
        d="M257 16C128.32 16 24 109.12 24 224c0 46.67 17.22 89.76 46.3 124.46L42 496l147.27-72.93A258.7 258.7 0 00257 432c128.68 0 233-93.12 233-208S385.68 16 257 16zm0 216a8 8 0 118-8 8.011 8.011 0 01-8 8zm-88-8a8 8 0 118 8 8.011 8.011 0 01-8-8zm160 0a8 8 0 118 8 8.011 8.011 0 01-8-8z"
        fill="#57a4ff"
      />
      <g fill="#004fac">
        <path d="M426.08 70.95C380.61 30.36 320.2 8 256 8S131.39 30.36 85.92 70.95C40.19 111.78 15 166.13 15 224c0 45.95 15.8 89.66 45.74 126.64l-27.6 143.85a8 8 0 0011.41 8.68l144.58-71.6A266.9 266.9 0 00256 440c64.2 0 124.61-22.36 170.08-62.95C471.81 336.22 497 281.87 497 224s-25.19-112.22-70.92-153.05zm-235.72 344.4a7.982 7.982 0 00-5.64.55L51.89 481.68l25.27-131.71a8.012 8.012 0 00-1.73-6.65C46.36 308.64 31 267.38 31 224 31 113.72 131.93 24 256 24s225 89.72 225 200-100.93 200-225 200a250.962 250.962 0 01-65.64-8.65z" />
        <path d="M257 200a24 24 0 1024 24 24.032 24.032 0 00-24-24zm0 32a8 8 0 118-8 8.011 8.011 0 01-8 8zM177 200a24 24 0 1024 24 24.032 24.032 0 00-24-24zm0 32a8 8 0 118-8 8.011 8.011 0 01-8 8zM337 200a24 24 0 1024 24 24.032 24.032 0 00-24-24zm0 32a8 8 0 118-8 8.011 8.011 0 01-8 8z" />
      </g>
    </svg>
  )
}

export default SvgChat
